import { Search } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /**
   * 'sm' is the original: a compact w-56 box for sitting inside a panel header.
   * 'md' matches the height of a `px-3 py-2 text-sm` select or button, for a
   * toolbar row where a search sits beside them — at 'sm' it reads as a
   * different, smaller control and the row looks ragged. It fills its wrapper,
   * so the caller sets the width.
   */
  size?: 'sm' | 'md';
}

/**
 * Small search input with a leading Search icon. Extracted from the
 * identical markup that lived in SubMetricsManagePanel and the
 * EmployeeScorePage metric tab so the styling stays in one place.
 */
export function SearchInput({
  value, onChange, placeholder = 'Search employee / store', size = 'sm',
}: SearchInputProps) {
  const md = size === 'md';
  return (
    <div className="relative">
      <Search
        className={`pointer-events-none absolute top-1/2 -translate-y-1/2 text-gray-400 ${
          md ? 'left-3 h-4 w-4' : 'left-2 h-3.5 w-3.5'
        }`}
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`border border-gray-300 focus:border-primary-500 focus:outline-none ${
          md
            ? 'w-full rounded-lg py-2 pl-9 pr-3 text-sm focus:ring-2 focus:ring-primary-100'
            : 'w-56 rounded-md py-1 pl-7 pr-2 text-xs'
        }`}
      />
    </div>
  );
}
